module.exports = __webpack_public_path__ + "img/amazonpay.95c925d3.svg";